import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ComponentIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.82277 13.1987L4.74994 15L11.9999 19.25L19.2499 15L16.1771 13.1987M11.9999 15.25L4.74994 11L11.9999 6.75L19.2499 11L11.9999 15.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
